import { render, staticRenderFns } from "./SalePointRegister.vue?vue&type=template&id=27647a5f&"
import script from "./SalePointRegister.vue?vue&type=script&lang=js&"
export * from "./SalePointRegister.vue?vue&type=script&lang=js&"
import style0 from "./SalePointRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports